import { render, staticRenderFns } from "./DetailConsumed.vue?vue&type=template&id=9c41a934&"
import script from "./DetailConsumed.vue?vue&type=script&lang=js&"
export * from "./DetailConsumed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports